import { usePaymentApiV1 } from '../../clients/quipli-service/payment/payment-api-v1';
import { useEffect, useState } from 'react';
import { BankAccount } from '@stripe/stripe-js';
import { Typography } from '../../components/typography/typography';
import { Card } from '../../components/card/card';
import { Button } from '../../components/form/button';
import { StripeFinancialsConnection } from './financial-connections';
import { Modal } from '../../components/modal/modal';

export const BankDetails = () => {
  const { getBankDetails } = usePaymentApiV1();

  const [bankDetails, setBankDetails] = useState<BankAccount[]>();
  const [addBankDetails, setAddBankDetails] = useState<boolean>(false);
  const [fullName, setFullName] = useState<string>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  useEffect(() => {
    getBankDetails().then((bankAccounts) => {
      setBankDetails(bankAccounts);
    });
  }, [addBankDetails]);

  const BankAccountList = ({ bankAccounts }: { bankAccounts: BankAccount[] }) => {
    return (
      <div className="bank-account-table gap-2 flex flex-column p-2 pt-0">
        {(bankAccounts.length || 0) > 0 && (
          <table>
            <thead>
              <tr>
                <th className="text-left m-2 p-2">
                  <Typography type={'text-md'}>Institution Name</Typography>
                </th>
                <th className="text-center m-2 p-2">
                  <Typography type={'text-md'}>Routing Number</Typography>
                </th>
                <th className="text-center m-2 p-2">
                  <Typography type={'text-md'}>Account</Typography>
                </th>
                <th className="text-left m-2 p-2">
                  <Typography type={'text-md'}>Account Status</Typography>
                </th>
              </tr>
            </thead>
            <tbody>
              {bankAccounts.map((account) => {
                return (
                  <tr key={account.id}>
                    <td className="text-left">{account.bank_name}</td>
                    <td className="text-center">{account.routing_number}</td>
                    <td className="text-center">{account.last4}</td>
                    <td className="text-left">{account.status}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  };

  return (
    <div className="flex flex-column gap-4">
      <h2>Payout Bank Details</h2>
      <div className="flex justify-between">
        <Card>{bankDetails && <BankAccountList bankAccounts={bankDetails}></BankAccountList>}</Card>
      </div>
      <div className="flex items-center">
        <Button
          className="button button-primary"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          Update Bank Account
        </Button>
      </div>
      {isModalOpen && (
        <Modal
          title={`Bank Account Setup`}
          isOpen={isModalOpen}
          close={() => {
            setIsModalOpen(false);
            setFullName(undefined);
          }}
        >
          <div className="min-w-full w-[370px] flex flex-col gap-2 items-stretch">
            <Typography type="text-sm" className="text-[var(--grey-700)]">
              Full Name
            </Typography>
            <input
              className=" h-[44px] border border-[var(--grey-300)] rounded-md px-4"
              type="text"
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
              }}
            />
            <div className="flex gap-4 flex-end mt-4">
              <Button
                className="button-secondary"
                onClick={() => {
                  setIsModalOpen(false);
                  setFullName(undefined);
                }}
              >
                Cancel
              </Button>
              <Button
                className="button-primary"
                onClick={() => {
                  setIsModalOpen(false);
                  setAddBankDetails(true);
                }}
              >
                Continue
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {addBankDetails && fullName && (
        <StripeFinancialsConnection fullName={fullName} close={() => setAddBankDetails(false)} />
      )}
    </div>
  );
};
